export const WarningIcon = () => (<svg width="31.5" height="29.25" viewBox="0 0 31.5 29.25">
    <path d="M2.25,32.625h31.5L18,3.375Zm17.438-4.5H16.313V24.75h3.375Zm0-5.625H16.313V15.75h3.375Z" transform="translate(-2.25 -3.375)" fill="#de0601" />
</svg>)
